query BIMClass(
    $id: ID!
) {
    bimClass(
        id: $id
        tag: "latest"
    ) {
        id

        data {
            type

            name(language: "en") {
                text
            }

            componentTypes {
                id
                name {
                    language
                    text
                }
                bimClass {
                    id
                }
            }
        }
    }
}
